import { render, staticRenderFns } from "./ServerErrors.vue?vue&type=template&id=664d4cb7&"
import script from "./ServerErrors.vue?vue&type=script&lang=js&"
export * from "./ServerErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports